import React from 'react'
import { BRANCH_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import BranchForm from './BranchForm'

export default function BranchUpdate({ onCancel, onUpdate, task }) {
    const url = BRANCH_DETAIL.replace('{id}', task.id)
    const taskUpdate = usePutRequest({ url })

    async function onSubmit(data, actions) {
        await taskUpdate.request({
            data: {
                ...data,
                dueTime: data.dueTime ? data.dueTime : null,
            },
        })
        actions.resetForm()
        onUpdate()
    }

    return (
        <div>
            <b>Изменить задачу</b><br /><br />

            <BranchForm
                initialValues={task}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={taskUpdate.loading} />
        </div>
    )
}
